import script from "./ScreeningExitModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreeningExitModal.vue?vue&type=script&setup=true&lang=js"

import "./ScreeningExitModal.vue?vue&type=style&index=0&id=fb4ea750&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb4ea750"]])

export default __exports__